import { FC, ReactNode } from 'react';

import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import { Box, Tooltip, Typography } from '@mui/material';

interface SecondaryTooltipProps {
    title: string
    header?: string
    children?: ReactNode
}

const SecondaryTooltip: FC<SecondaryTooltipProps> = ({ title, header, children }) => {
    return (
        <Tooltip
            title={
                <Box>
                    {header && (
                        <Typography
                            variant="subtitle1"
                            fontWeight="bold"
                            color="black"
                            marginBottom="8px"
                        >
                            {header}
                        </Typography>
                    )}
                    <Typography variant="body2">{title}</Typography>
                </Box>
            }
            placement="top"
            arrow
            slotProps={{
                tooltip: {
                    sx: {
                        backgroundColor: 'background.paper',
                        color: 'text.secondary',
                        boxShadow: 4,
                        padding: 2,
                        borderRadius: 1,
                        '&::before': {
                            content: '""',
                            display: 'block',
                            width: '100%',
                            height: 10,
                            backgroundColor: 'orange.light2',
                            borderTopLeftRadius: 1,
                            borderTopRightRadius: 1,
                            position: 'absolute',
                            top: 0,
                            left: 0,
                        },
                    },
                },
                arrow: {
                    sx: {
                        color: 'background.paper',
                    },
                },
            }}
        >
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    cursor: 'pointer',
                    color: 'orange.main',
                }}
            >
                {children || <HelpOutlineIcon />}
            </Box>
        </Tooltip>
    );
};

export default SecondaryTooltip;
